export const rangeColors = [
    '#38D9A9', // theme.colors.teal[4]
    '#4DABF7', // theme.colors.blue[4]
    '#FFA94D', // theme.colors.orange[4]
    '#3BC9DB', // theme.colors.cyan[4]
    '#22B8CF', // theme.colors.cyan[5]
    '#339AF0', // theme.colors.blue[5]
    '#94D82D' // theme.colors.lime[5]
];

export const rangeColorNames = ['teal', 'blue', 'cyan', 'teal', 'blue', 'cyan', 'teal'];
